export const parseRecentlyViewedDate = (date: Date) => {
  const isToday = date.toDateString() === new Date().toDateString()
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const formattedDate = date.toLocaleString('en-US', {
    timeZone,
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    ...(!isToday && { month: 'numeric' }),
    ...(!isToday && { day: 'numeric' }),
    ...(!isToday && { year: 'numeric' }),
  })

  return (isToday ? 'Today at ' : '') + formattedDate.split(',').join(' at ')
}